<template>
  <RouterLink :to="to">
    <div class="mobile-menu-item">
      <component :is="icon" color="#ffffff99" />
      <span>{{ label }}</span>
    </div>
  </RouterLink>
</template>

<script lang="ts">
import { Component, defineComponent, PropType } from "vue"
import { RouteLocationRaw, RouterLink } from "vue-router"

export default defineComponent({
  name: "MobileMenuItem",
  props: {
    label: String,
    icon: {
      type: Object as () => Component,
      required: true,
    },
    to: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      required: true,
    },
  },
  components: { RouterLink },
  computed: {},
  methods: {},
})
</script>
<style scoped lang="scss">
.mobile-menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  justify-content: center;
  width: 60px;
  height: 44px;

  span {
    white-space: nowrap;
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.4px;
    color: rgba(255, 255, 255, 0.6);
  }
}
</style>
